module.exports = __webpack_public_path__ + "img/3.bb7f6600.png";